import { ConfigurationTypes } from "../../../../vendor_core/core/src/const/ConfigurationTypes";
import ConfigManager from "../../../../vendor_core/core/src/managers/ConfigManager";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import * as GameCommands from "../../../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../../../vendor_core/src/commands/VendorCommands";
import { UIButtons } from "../../../../vendor_core/core/src/ui/UIButtons";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import SwitchButton from "../../../../vendor_core/core/src/views/components/SwitchButton";
import DoubleChanceModel from "../../../model/DoubleChanceModel";
import Layout from "../../../../vendor_core/core/src/utils/Layout";
import SoundController from "../../../../vendor_core/core/src/utils/SoundController";
import Utils from '../../Utils';
import App from '../../../../vendor_core/core/src/App';
import SoundVars from '../../../../vendor_core/core/src/const/SoundVars';
import { DefaultStates } from '../../../../vendor_core/core/src/states/DefaultStates';
import StateMachine from "../../../../vendor_core/core/src/states/StateMachine";
import AutoplayModel from '../../../../vendor_core/core/src/model/AutoplayModel';
import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import BuyFeatureConfig from "../../../configs/BuyFeatureConfig";
import BuyFeatureModel from "../../../../vendor_core/core/src/model/BuyFeatureModel";
import ConsoleUtil from "../../../../vendor_core/core/src/utils/ConsoleUtil";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import SceneView from "../../../../vendor_core/core/src/views/SceneView";
import Button from "../../../../vendor_core/core/src/views/components/Button";
import VendorModel from "../../../../vendor_core/src/model/VendorModel";

export async function SetBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    ChangeBetCommand(betData);
    VendorCommands.SetBetCommand(betData);
}

export function ShowBuyFeatureOptions() {
    const price = getScatterBoostCost()
    // if (!(BetModel.balance - price >= 0)) {
    //     return;
    // }

    const enableBuyFeature: boolean = !(VendorModel.settings?.disableBuyFeature === "true");
    const enableDoubleChance: boolean = !(VendorModel.settings?.scatterBoostDisable === "true");

    let isActive = !DoubleChanceModel.isActivated;
    // const dcButton = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene()
    //     .buttons.get("buyfeatureSpin") as SwitchButton;
    const sceneBetBar: SceneView = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene();
    const dcButton: SwitchButton = sceneBetBar.buttons.get(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt") as SwitchButton;
    dcButton.switch(isActive);


    if (!DoubleChanceModel.isActivated) {
        // SoundController.playSound(GameSoundVars.SCATTER_BOOST_ON);
    }

    const fbButton: Button = sceneBetBar.buttons.get("feature");
    if (enableBuyFeature) {
        fbButton.setEnabled(!isActive);
        sceneBetBar.groups.get("btn_buy_feature").alpha = isActive ? 0.5 : 1;
    } else {
        fbButton.setEnabled(false);
        sceneBetBar.groups.get("btn_buy_feature").alpha = 0;
    }

    const spinBtn: SwitchButton = sceneBetBar.buttons.get("spin") as SwitchButton;
    spinBtn.switch(isActive);

    const betBarScene = ViewManager.getLayer("BetBarBottom").getCurrentScene();
    const betField = betBarScene.sceneMoneyFields.get("bet");
    ConsoleUtil.log(betField)
    
    const scene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
    const anim = scene.spineAnimations.get("frame_anticipation");

    if (isActive) {
        DoubleChanceModel.isActivated = true;
        BuyFeatureModel.mode = 1;
        const scatterBoostScene = ViewManager.getLayer("ScatterBoostCost").setScene("open");
        ViewManager.moveLayerBehind("ScatterBoostCost", "SplashOverlay");
        const cost = getScatterBoostCost();
        scatterBoostScene.sceneMoneyFields.get("total_cost").value = cost;
        betBarScene.sceneMoneyFields.get("bet_amountAlt").alpha = 0.2;
        anim.playAsync("mg_to_db").then(() => anim.playAsync("loop_db"));
    } else {
        DoubleChanceModel.isActivated = false;
        BuyFeatureModel.mode = -1;
        ViewManager.getLayer("ScatterBoostCost").clear();
        betBarScene.sceneMoneyFields.get("bet_amountAlt").alpha = 1;
        anim.playAsync("db_to_mg").then(() => anim.playAsync("loop_mg"));
    }

    if (!enableDoubleChance) sceneBetBar.groups.get("btn_double_chance").alpha = 0;
    if (!enableBuyFeature) sceneBetBar.groups.get("btn_buy_feature").alpha = 0;
}

export function ChangeBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    if (DoubleChanceModel.isActivated) {
        const scatterBoostScene = ViewManager.getLayer("ScatterBoostCost").getCurrentScene();

        let BoostCost = getScatterBoostCost(betData.value, betData.coinIndex)

        scatterBoostScene.sceneMoneyFields.get("total_cost").value = BoostCost

        const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene();
        betBarSceen.sceneMoneyFields.get("dc_bet_amount").value = BoostCost
    }
}

export function ToggleBetPopupCommand(visible) {
    const isReplay: boolean = GameModel.isReplay;
    const enableBuyFeature: boolean = !(VendorModel.settings?.disableBuyFeature === "true");
    const enableDoubleChance: boolean = !(VendorModel.settings?.scatterBoostDisable === "true");

    if (visible) {
        ViewManager.resetLayersZOrder();
    } else {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, "BetBarPopups");
    }
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) /* && Configs.game.clientConfig.quickStop */;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
    const btnValue = betBarSceen.sceneMoneyFields.get("dc_bet_amount");
    const buttons = betBarSceen.buttons;

    const cost = getScatterBoostCost();

    btnValue.value = cost;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    disabledBtnNames.push("feature");
    // disabledBtnNames.push("buyfeatureSpin");
    disabledBtnNames.push(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt");

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            if (name == "feature") {
                btn.setEnabled(visible != true
                    ? false
                    : DoubleChanceModel.isActivated
                        ? false
                        : true);
            } else {
                btn.setEnabled(visible != true ? false : true);
            }
        }
    });

    const dcButton: SwitchButton = betBarSceen.buttons.get(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt") as SwitchButton;

    // spaghetti shit (this was for high priority task)
    if (isReplay) {
        dcButton.setEnabled(false);

        buttons.forEach((btn, name) => {
            if(disabledBtnNames.indexOf(name) != -1) {
                if (name == "feature" || name == "spin") {
                    btn.setEnabled(false);
                }
            }
        });

        if (!enableDoubleChance) {
            betBarSceen.groups.get("btn_double_chance").alpha = 0;
        }
        if (!enableBuyFeature) {
            betBarSceen.groups.get("btn_buy_feature").alpha = 0;
        }
    } else {
        if (!enableDoubleChance) {
            betBarSceen.groups.get("btn_double_chance").alpha = 0;
            dcButton.setEnabled(false);
        }
        if (!enableBuyFeature) {
            buttons.forEach((btn, name) => {
                if(disabledBtnNames.indexOf(name) != -1) {
                    if (name == "feature") {
                        btn.setEnabled(false);
                    }
                }
            });
            betBarSceen.groups.get("btn_buy_feature").alpha = 0;
        }
    }

    GameCommands.ToggleBetPopupCommand();
}

export function getScatterBoostCost(totalBet = BetModel.totalBet, coinIndex = BetModel.coinSizeIndex) {

    // const betMultiplier =  BetModel.creditValues[coinIndex];
    // const scatterBoostCreditsPerBet = DoubleChanceConfig.scatterBoostCreditsPerBet;
    // const value = betMultiplier * scatterBoostCreditsPerBet + totalBet;

    if (GameModel.isReplay && DoubleChanceModel.mode === 1) {
        const scene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const anim = scene.spineAnimations.get("frame_anticipation");
        anim.playAsync("loop_db")
    }

    const betMultiplier =  BuyFeatureConfig.betMultiplier[1];
    const value = betMultiplier * BetModel.creditValues[coinIndex];

    return value;

}

export function ToggleAutoplayPopupCommand(visible) {
    const isReplay: boolean = GameModel.isReplay;
    const enableBuyFeature: boolean = !(VendorModel.settings?.disableBuyFeature === "true");
    const enableDoubleChance: boolean = !(VendorModel.settings?.scatterBoostDisable === "true");

    if (visible) {
        ViewManager.resetLayersZOrder();
    } else {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, "BetBarPopups");
    }
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && GameModel.turboSpin;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const buttons = ViewManager.getLayer(DefaultLayers.BetBar)
        .setScene().buttons;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    disabledBtnNames.push("feature");
    // disabledBtnNames.push("buyfeatureSpin");
    disabledBtnNames.push(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt");

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            if (name == "feature") {
                btn.setEnabled(visible != true
                    ? false
                    : DoubleChanceModel.isActivated
                        ? false
                        : true);
            } else {
                btn.setEnabled(visible != true ? false : true);
            }
        }
    });

    const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
    const dcButton: SwitchButton = betBarSceen.buttons.get(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt") as SwitchButton;

    // spaghetti shit (this was for high priority task)
    if (isReplay) {
        dcButton.setEnabled(false);

        buttons.forEach((btn, name) => {
            if(disabledBtnNames.indexOf(name) != -1) {
                if (name == "feature" || name == "spin") {
                    btn.setEnabled(false);
                }
            }
        });

        if (!enableDoubleChance) {
            betBarSceen.groups.get("btn_double_chance").alpha = 0;
        }
        if (!enableBuyFeature) {
            betBarSceen.groups.get("btn_buy_feature").alpha = 0;
        }
    } else {
        if (!enableDoubleChance) {
            betBarSceen.groups.get("btn_double_chance").alpha = 0;
            dcButton.setEnabled(false);
        }
        if (!enableBuyFeature) {
            buttons.forEach((btn, name) => {
                if(disabledBtnNames.indexOf(name) != -1) {
                    if (name == "feature") {
                        btn.setEnabled(false);
                    }
                }
            });
            betBarSceen.groups.get("btn_buy_feature").alpha = 0;
        }
    }

    GameCommands.ToggleAutoplayPopupCommand();
}

export function SpinCommand(playSpinSound: boolean) {
    let skippable = new Array<string>(
      DefaultStates.Idle,
      DefaultStates.Finish,
      DefaultStates.ShowWin,
      "coin_collect"
    );

    if (StateMachine.currentState.name == DefaultStates.ShowWin) {
      const elapsedSeconds = (new Date().getTime() - (<any>StateMachine.currentState).timer) / 1000;
      if (elapsedSeconds < (App.config.autoSpinDelay || 0.1)) {
        // Ensure the player will see the win at least for a small amount of time.
        // Without this check if the player holds the spacebar, s/he will miss the winnings.
        return;
      }
    }

    if (!skippable.includes(StateMachine.currentState.name)) {
      // Fixes the nbt game hangs, when clicking fast
      // on the spin button, during big win
      return;
    }

    if (!AutoplayModel.isAutoSpinActive()) {
        SoundController.playSound(SoundVars.BUTTON_SPIN, false);
    }

    StateMachine.skip();
}

export function ToggleSettingsCommand(visible) {
    VendorCommands.ToggleSettingsCommand();
    if (visible) {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, DefaultLayers.MenusBackground);
        Utils.changeBottomBarAlpha();
    } else {
        Utils.changeBottomBarAlpha(0.7);
        ViewManager.resetLayersZOrder();
    }
}

export function resetAudionCTX() {
    if (!SoundController.isSoundCtxEventAdded) {
        document.addEventListener("visibilitychange", () => {
        if (document.visibilityState == "hidden") {
            SoundController.toggleMusicWhenVisibilityChange();
            App.instance.paused = true;
        } else {
            App.instance.paused = false;
            SoundController.toggleMusicWhenVisibilityChange();
        }
        });
        SoundController.isSoundCtxEventAdded = true;
    }
}

export function UpdateUICommand() {
    GameCommands.UpdateWinCommand({ win: SpinModel.accumulatedWin });
    GameCommands.UpdateBalanceCommand();
    GameCommands.UpdateSettingsCommand();
    GameCommands.UpdateAutoplayCommand();
    GameCommands.UpdateBetCommand();
}
